import {testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {useVehiclesActionCallback} from '../../hooks/useVehiclesActionCallback';

export function OSVehicles() {
  const [actionCallback] = useVehiclesActionCallback();

  return (
    <DmsDataGrid
      gridCode="vehicle-opensearch"
      data-testid={testIds.vehicles.vehicleOpenSearch()}
      // eslint-disable-next-line no-restricted-syntax
      key="vehicle-opensearch"
      actionCallback={actionCallback}
    />
  );
}
